import PivaInp from "../../components/PivaInp";
import EmailInp from "../../components/EmailInp";
import DefInp from "../../components/DefInp";
import LbsSelect from "../../components/LbsSelect";
import Fnc from "../../library/Functions";
import React, { useState, useEffect } from 'react';
import {
	useNavigate
} from "react-router-dom";
import API from '../../library/ApiManager';
import DialogMsg from '../../components/DialogMsg';
import Loading from '../../components/Loading';



function RegEngine(props) {

	const regEndPage = Fnc.currEnv().registrationEnd;

	const [isLoading, setIsLoading] = useState(false);
	const [invoiceData, setInvoiceData] = useState({
		"iva": null,
		"cf": null,
		"ivacf": null,
		"rs": null,
		"comp": null,
		"nam": null,
		"snam": null,
		"city": null,
		"fz": null,
		"prov": null,
		"topo": null,
		"zip": null,
		"num": null,
		"sdi": null,
		"email": null,
		"type": "N",
		"cc": {},
		"fCond": true,
		"fProm": false,
		"gtw": null,
		"phone": null,
		"timeSlot": null
	});
	const [invoiceHash, setInvoiceHash] = useState(null);
	const [disableNext, setDisableNext] = useState(true);
	const [forceDisabled, setForceDisabled] = useState(true);
	const [dlgConf, setDlgConf] = useState(null);
	const [loadingState, setLoadingState] = useState("open");


	const navigate = useNavigate(); 

	useEffect(() => {
		// Similar to componentDidMount and componentDidUpdate:

		let courtesyTime = Fnc.checkState(1);

		if(courtesyTime) {
		  navigate(Fnc.currEnv().courtesyPage);
		} else {

			isInvoiceOk(invoiceData);

			API.getUser((usr) => {
				let isLogged = usr && usr.response.code === 'OK';
	
				if (!isLogged) {
	
					setLoadingState("");
	
				} else {
					setLoadingState("");
					Fnc.gaException("[RegEngine.js@useEffect] Get User in KO", JSON.stringify(usr), true, Fnc.ExcCatgory.REGISTRATION.val);
					setDlgConf(new Fnc.DlgConf("[LGGD] Non è possibile registrarsi", "Sei già nostro cliente non è necessario registrarsi nuovamente", true, "Chiudi", ""));
				}
			});

		}

	}, [invoiceHash]); //empty array => chiama solo una volta. con un valore nell'array la chiama ad ogni cambiamento di quel valore/i

	function createInvoceHash(invoiceData) {
		return Fnc.jsonSerialize(invoiceData);
	}

	function isInvoiceOk(invoiceData) {
		let ret = true;
		ret = ret && (Fnc.validatePiva(invoiceData.iva) === Fnc.EnmPiva.OK);
		ret = ret && invoiceData.rs && invoiceData.rs.length > 0;
		ret = ret && invoiceData.city && invoiceData.city.length > 0;
		ret = ret && invoiceData.prov && invoiceData.prov.length > 0;
		ret = ret && invoiceData.topo && invoiceData.topo.length > 0;
		ret = ret && (Fnc.validateEmail(invoiceData.email) === Fnc.EnmEmail.OK);
		setDisableNext(ret ? "" : true);
	}

	function callbackCustomer(data) {
		Fnc.log("[PIVA]", data, Fnc.LogLvl.DEBUG);
		if (data.code === Fnc.EnmPiva.OK) {
			let customer = data.obj;
			manageCustomer(customer);
		} else if (data.code === Fnc.EnmPiva.NOT_FOUND) {
			let pivaVal = data.obj;
			const cloneInvoiceData = Object.assign({}, invoiceData);
			cloneInvoiceData.iva = pivaVal;
			cloneInvoiceData.ivacf = pivaVal;
			setInvoiceData(cloneInvoiceData);
			setInvoiceHash(createInvoceHash(cloneInvoiceData));
			setForceDisabled(false);
		}

	}

	function manageCustomer(customer) {
		if (customer && customer.invoicingData) {

			let address = customer.invoicingData["indirizzo"];
			let addParsed = Fnc.cleanAddress(address);

			const cloneInvoiceData = Object.assign({}, invoiceData);
			cloneInvoiceData.iva = customer.invoicingData["piva"];
			cloneInvoiceData.ivacf = customer.invoicingData["piva"];
			cloneInvoiceData.rs = customer.invoicingData["ragSoc"];
			cloneInvoiceData.comp = customer.invoicingData["ragSoc"];
			cloneInvoiceData.nam = customer.invoicingData["name"];
			cloneInvoiceData.snam = customer.invoicingData["surname"];
			cloneInvoiceData.city = customer.invoicingData["citta"];
			cloneInvoiceData.fz = customer.invoicingData["frazione"];
			cloneInvoiceData.prov = customer.invoicingData["provincia"];
			cloneInvoiceData.topo = addParsed.topo;
			cloneInvoiceData.num = addParsed.civico;
			cloneInvoiceData.zip = customer.invoicingData["cap"];
			cloneInvoiceData.sdi = customer.invoicingData["sdi"];
			cloneInvoiceData.email = customer.invoicingData["email"];
			if (props.selComm != null) {
				cloneInvoiceData.cc = props.selComm;
				cloneInvoiceData.cc['products'] = null;
			}
			//setCustomer(data);
			setInvoiceData(cloneInvoiceData);
			setInvoiceHash(createInvoceHash(cloneInvoiceData));
		}
	}

	function callbackEmail(data) {
		Fnc.log("EMAIL:", data, Fnc.LogLvl.DEBUG);
		const cloneInvoiceData = Object.assign({}, invoiceData);
		cloneInvoiceData.email = data.obj;
		setInvoiceData(cloneInvoiceData);
		setInvoiceHash(createInvoceHash(cloneInvoiceData));
	}

	function callbackRagSoc(data) {
		Fnc.log("RAGSOC:", data, Fnc.LogLvl.DEBUG);
		const cloneInvoiceData = Object.assign({}, invoiceData);
		cloneInvoiceData.rs = data.obj;
		cloneInvoiceData.comp = data.obj;
		setInvoiceData(cloneInvoiceData);
		setInvoiceHash(createInvoceHash(cloneInvoiceData));
	}


	function callbackCity(data) {
		Fnc.log("[CITY]", data, Fnc.LogLvl.DEBUG);
		const cloneInvoiceData = Object.assign({}, invoiceData);
		if (data.code === Fnc.EnmGen.OK && data.obj.elm) {
			cloneInvoiceData.city = data.obj.elm.com;
			cloneInvoiceData.prov = data.obj.elm.prov;
			cloneInvoiceData.fz = data.obj.elm.fraz;
			//setTesttmp(data.elm.com);
		} else {
			cloneInvoiceData.city = null;
			cloneInvoiceData.prov = null;
			cloneInvoiceData.fz = null;
		}
		setInvoiceData(cloneInvoiceData);
		setInvoiceHash(createInvoceHash(cloneInvoiceData));

	}

	function callbackAddress(data) {
		Fnc.log("[ADDRESS]", data, Fnc.LogLvl.DEBUG);
		const cloneInvoiceData = Object.assign({}, invoiceData);
		if (data.code === Fnc.EnmGen.OK && data.obj && data.obj.elm) {
			let addParsed = Fnc.cleanAddress(data.obj.elm.topo);
			cloneInvoiceData.topo = addParsed.topo;
			cloneInvoiceData.num = addParsed.civico;
		} else {
			cloneInvoiceData.topo = null;
		}
		setInvoiceData(cloneInvoiceData);
		setInvoiceHash(createInvoceHash(cloneInvoiceData));
	}

	function getCity() {
		return invoiceData.city != null ? (invoiceData.fz ? invoiceData.fz + ", " : "") + invoiceData.city + " (" + invoiceData.prov + ")" : "";
	}

	function getAddress() {
		return invoiceData.topo != null ? (invoiceData.topo != null ? invoiceData.topo : "") + " " + (invoiceData.num != null ? invoiceData.num : "") : "";
	}

	function performRegistration() {

		setIsLoading(true);


		API.getAllProducts((prods) => {

			let pObjToBuy = null;
			if (window.location.pathname === Fnc.currEnv().registrationCampagna) {
				pObjToBuy = prods.filter(p => {
					return p.code === "CMFTF";
				})
			} else if (window.location.pathname === Fnc.currEnv().registrationSito) {
				pObjToBuy = prods.filter(p => {
					return p.code === "SDIYF";
				})
			}

			if (pObjToBuy !== null) {

				API.basketDelAll((data) => {

					API.addItem(pObjToBuy, (data) => {

						let fpt = Fnc.jsonSerialize(invoiceData);
						API.checkoutDirect(fpt, "", (data) => {
							Fnc.log("CHECKOUT DIRECT OK", data, Fnc.LogLvl.DEBUG);
							setIsLoading(false);
							if (data && data.response && data.response.code === 'OK') {
								Fnc.gaTrackRegistrationFreeProd("end",pObjToBuy[0].code, false); //traccia su GA una pagina vista fake per obiettivo canalizzato
								navigate(regEndPage);
							} else {
								Fnc.gaTrackRegistrationFreeProd("err",pObjToBuy[0].code, false); //traccia su GA una pagina vista fake per obiettivo canalizzato
								setDlgConf(new Fnc.DlgConf("[CKDIRKO] Non è possibile registrarsi", "Ci sono problemi tecnici, ci scusiamo per il disguido", true, "Chiudi", ""));
								Fnc.gaException("[RegEngine.js@performRegistration] Checkout direct KO per registrazione", JSON.stringify(data), true, Fnc.ExcCatgory.REGISTRATION.val);
							}

						});

					});

				});

			} else {
				setIsLoading(false);
				Fnc.gaException("[RegEngine.js@performRegistration] Impossibile fare la registrazione dato che non ci sono prodotti settati", JSON.stringify(prods), true, Fnc.ExcCatgory.REGISTRATION.val);
				setDlgConf(new Fnc.DlgConf("[NOPRD] Non è possibile registrarsi", "Ci sono problemi tecnici, ci scusiamo per il disguido", true, "Chiudi", ""));
			}

		});

	}

	function onCondPromChanged(e) {
		const cloneInvoiceData = Object.assign({}, invoiceData);
		cloneInvoiceData.fProm = e.target.checked;
		setInvoiceData(cloneInvoiceData);
		setInvoiceHash(createInvoceHash(cloneInvoiceData));
	  }

	function disableSumbit(e) {
		e.preventDefault();
	}

	function gotoAreaClienti() {
		let areaClientiPath = Fnc.currEnv().areaClientiPath;
		window.location.href = areaClientiPath;
	}

	return (
		<>
			<div className="iol-lrcp-form-wrapper col-xl-5 offset-xl-1">
				<div className="row adjustMargin">
					<div className="iol-lrpc-form order-3 order-md-1">
						<form onSubmit={disableSumbit}>
							<div className="form-group">
								<PivaInp callback={callbackCustomer} iva={""} loadData={false} isLogged={false} required={true} />
							</div>
							<div className="form-group">
								<EmailInp callback={callbackEmail} email={""} isLogged={false} required={true} />
							</div>
							{!forceDisabled &&
								<>
									<div className="form-group">
										<DefInp label="Ragione sociale azienda" callback={callbackRagSoc} required={true} forceDisabled={forceDisabled} value={invoiceData.rs} />
									</div>
									<div className="form-group">
										<LbsSelect label="Comune" forceDisabled={forceDisabled} required={true} callback={callbackCity} value={getCity()} type="city" preAppendVal="" />
									</div>
									<div className="form-group">
										<LbsSelect label="Indirizzo di fatturazione" forceDisabled={forceDisabled} required={true} callback={callbackAddress} value={getAddress()} type="address" preAppendVal={invoiceData.city} />
									</div>
								</>
							}

							<div className="caption">Proseguendo accetti le <a className="fucsia-text" href="/wp-content/plugins/iol-customize/docs/condizioni_generali_di_servizio_e_privacy.pdf"
								target="_blank">condizioni di servizio</a> e dichiari di aver preso visione <a className="fucsia-text" href="/archivio/informativa-privacy/"
									target="_blank">dell'informativa privacy</a>
								<div className="iol-checkboxes regContainer">
									<label className="checkbox-button regCheck">
										<input className="checkbox-button__input" id="choice1" type="checkbox" name="choice1" onChange={onCondPromChanged} ></input>
										<span className="checkbox-button__control"></span>
									</label>
									<span className="checkbox-button__label regLblCheck">Voglio restare aggiornato sulle promozioni e i servizi di Italiaonline come descritto <a className="fucsia-text" href="/archivio/informativa-privacy/"
										target="_blank">nell'informativa sulla privacy</a></span>
								</div>
							</div>
							<button className="fucsia-button semibold" onClick={performRegistration} disabled={disableNext} > Registrati
								<div id="loadReg" className={`loadingSet lds-ring ${isLoading ? "showLoading" : ""}`}>
									<div></div>
									<div></div>
									<div></div>
									<div></div>
								</div>
							</button>
							<div className="io-no-account-label">Hai già un account? <span><a className="fucsia-text" href="#" onClick={gotoAreaClienti}> Accedi</a></span></div>
						</form>
					</div>
				</div>
				<div className="iol-disclaimer">Il servizio è dedicato a te <span className="fucsia-text semibold">solo se hai una Partita IVA</span>.</div>
			</div>
			<Loading loadingState={loadingState} />
			{dlgConf != null &&
				<DialogMsg conf={dlgConf} ></DialogMsg>
			}
		</>
	);
}

export default RegEngine;
